var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex h-100"},[_c('totalSchoolList',{on:{"change":_vm.handleSelectTotalSchool}}),_c('subSchoolList',{ref:"subSchoolList",staticClass:"col ml-10"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }